import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBBtn,
  MDBBadge,
  MDBCol,
  MDBCardFooter,
} from "mdbreact";

import { faStar, faHeart } from "@fortawesome/free-solid-svg-icons";

import LocationMarkerGray from "../../../../assets/images/Icons/Links/Location Marker Gray.svg";
import { useSelector } from "react-redux";
import { Language } from "../../../../redux/store/base/language";

interface PostItemProps {
  Name: string;
  Profile: any;
  Location: string;
  Rating: number;
  Likes: number;
  Specializ: string[];
  PostText: string;
}

const PostItem = (props: PostItemProps) => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );

  return (
    <MDBCol md={"4"} sm={"6"} xs={"12"} className="mt-3">
      <MDBCard>
        <MDBCardHeader>
          <div className="avatar">
            <img src={props.Profile} alt="" />
          </div>
          <div className="profile">
            <p className="name">{props.Name}</p>
            <p className="location">
              <img src={LocationMarkerGray} alt="" />
              {props.Location}
            </p>
            <p className="eval">
              <div className="ratting">
                <FontAwesomeIcon icon={faStar} className="d-inline-inline" />
                <span>{props.Rating}</span>
              </div>
              <div className="like mr-3">
                <FontAwesomeIcon icon={faHeart} className="d-inline-inline" />
                <span>
                  {props.Likes} {state?.likes}
                </span>
              </div>
            </p>
          </div>
        </MDBCardHeader>
        <MDBCardBody>
          <section className="specializ">
            {props.Specializ?.map((item, i) => (
              <MDBBadge key={i}>{item}</MDBBadge>
            ))}
          </section>
          <p className="text">{props.PostText}</p>
        </MDBCardBody>
        <MDBCardFooter>
          <MDBBtn outline color={"danger"}>
            {state?.consultInstantly}
          </MDBBtn>
          <MDBBtn color={"danger"}>{state?.bookAppointment}</MDBBtn>
        </MDBCardFooter>
      </MDBCard>
    </MDBCol>
  );
};

PostItem.prototype = {
  Name: PropTypes.node.isRequired,
  Profile: PropTypes.node.isRequired,
  Location: PropTypes.node.isRequired,
  Rating: PropTypes.node.isRequired,
  Likes: PropTypes.node.isRequired,
  Specializ: PropTypes.node.isRequired,
  PostText: PropTypes.node.isRequired,
};

export default PostItem;
